module.exports = __webpack_public_path__ + "static/media/blue-youtube-icon-71.c32196c6.png";